exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".collapseTitle__container___2qpLG {\n  font-size: 15px;\n  font-weight: 600;\n  line-height: 23px;\n  letter-spacing: -0.015em;\n  cursor: pointer;\n  padding: 0 28px;\n  float: none;\n  transition: 300ms; }\n  .collapseTitle__container___2qpLG .collapseTitle__arrow___cB1zp {\n    transition: 300ms;\n    color: #000000;\n    margin-left: 15px; }\n  .collapseTitle__container___2qpLG:hover {\n    color: #f94144; }\n    .collapseTitle__container___2qpLG:hover .collapseTitle__arrow___cB1zp {\n      color: #f94144; }\n", ""]);

// exports
exports.locals = {
	"container": "collapseTitle__container___2qpLG",
	"arrow": "collapseTitle__arrow___cB1zp"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"modules":true,"sourceMap":false,"minimize":true,"importLoaders":2,"localIdentName":"[name]__[local]___[hash:base64:5]"}!./node_modules/sass-loader/lib/loader.js?{"includePaths":["./src"]}!./src/components/SearchControls/SearchGroups/AllSearchControls/CollapseTitle/collapseTitle.scss
// module id = 4230
// module chunks = 6